export const BASE_URL = 'http://www.adultswim.com';
export const CLIPS_PER_PAGE = 30;
export const DATETIME_DISPLAY_FORMAT = 'MMMM Do YYYY';
export const SHOWS_BASE_URL = '/videos';
export const VIDEOS_API_ENDPOINT = '/videos/api/v2/videos';
export const VIDEOS_API_FIELDS = 'title,collection_title,slug,season_number,episode_number,description,auth,duration,tv_rating,launch_date,expiration_date,type,images,episode';
export const VIDEOS_API_SORT = 'season_number:desc,episode_number:desc,episode.order:asc,launch_date:desc';



// WEBPACK FOOTER //
// ./src/show-page/constants/config.js